<template>
  <section class="preview">
    <div>
      <mdb-modal fullHeight position="top" :show="modal" @close="modal = false">
        <mdb-modal-header>
          <mdb-modal-title>Crear línea de Contenido</mdb-modal-title>
        </mdb-modal-header>
        <form novalidate @submit.prevent="crearLine">
          <mdb-modal-body>
            <mdb-input
              placeholder="Nombre"
              class="mb-3 mt-0"
              v-model="nameLine"
              required
              invalidFeedback="Coloca el nombre"
            >
              <span class="input-group-text md-addon" slot="prepend">Nombre</span>
            </mdb-input>

            <mdb-input
              placeholder="Descripción"
              class="mb-3 mt-0"
              v-model="descriptionLine"
              required
              invalidFeedback="Descripción"
            >
              <span class="input-group-text md-addon" slot="prepend">Desripción</span>
            </mdb-input>
          </mdb-modal-body>
          <mdb-modal-footer>
            <mdb-btn color="secondary" @click.native="modal = false">Cerrar</mdb-btn>
            <mdb-btn type="submit" color="primary" :disabled="isLoadingLine">
              <span v-if="!isLoadingLine">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingLine"
              ></semipolar-spinner>
            </mdb-btn>
          </mdb-modal-footer>
        </form>
      </mdb-modal>
    </div>

    <form class="form" novalidate @submit.prevent="crear">
      <!-- Styled -->
      <mdb-input
        placeholder="Nombre"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="Coloca el nombre"
      >
        <span class="input-group-text md-addon" slot="prepend">Nombre</span>
      </mdb-input>

      <mdb-input
        placeholder="Descripción"
        class="mb-3 mt-0"
        v-model="description"
        required
        invalidFeedback="Dirección de calle"
      >
        <span class="input-group-text md-addon" slot="prepend">Desripción</span>
      </mdb-input>

      <div class="form-group">
        <label class="typo__label">Fecha de inicio</label>
        <b-form-input v-model="dateStart" type="date"></b-form-input>
      </div>

      <div class="form-group">
        <label class="typo__label">Fecha de cierre</label>
        <b-form-input v-model="dateEnd" type="date"></b-form-input>
      </div>

      <div class="form-group">
        <label class="typo__label">
          Líneas de contenido
          <i class="fas fa-plus-circle icono-crear mr-1" @click="modal = true"></i>
        </label>
        <multiselect
          v-model="linesSelected"
          :options="lines"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Selecciona líneas de contenido"
          label="name"
          track-by="id"
          :preselect-first="false"
        ></multiselect>
      </div>

      <div class="form-group">
        <label class="typo__label">Estereotipos</label>
        <multiselect
          v-model="stereotypesSelected"
          :options="stereotypes"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Selecciona Estereotipos"
          label="name"
          track-by="id"
          :preselect-first="false"
        ></multiselect>
      </div>

      <div class="form-group">
        <label class="typo__label">Promoción</label>
        <multiselect
          v-model="promotionSelected"
          :options="promotions"
          :multiple="false"
          :preserve-search="true"
          placeholder="Selecciona Promoción"
          label="name"
          track-by="id"
          :preselect-first="false"
        ></multiselect>
      </div>

      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import Multiselect from "vue-multiselect";
import { SemipolarSpinner } from "epic-spinners";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip
} from "mdbvue";
import store from "../../store";
export default {
  name: "modal-1",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner,
    Multiselect,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalTitle,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbIcon,
    mdbTextarea,
    mdbTooltip
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoading: false,
      modal: false,
      name: "",
      description: "",
      dateStart: "",
      dateEnd: "",
      lines: [],
      linesSelected: [],
      stereotypes: [],
      stereotypesSelected: [],
      promotions: [],
      promotionSelected: [],
      nameLine: "",
      descriptionLine: "",
      isLoadingLine: false
    };
  },
  async mounted() {
    var respuesta = await this.getLines();
    respuesta = await this.getStereotypes();
    respuesta = await this.getPromotions();
  },
  methods: {
    async getLines() {
      var lines = store.getters.getLines;
      if (lines.length == 0) {
        await store.dispatch("getLines").then(() => {
          lines = store.getters.getLines;
          this.lines = lines;
          return;
        });
      } else {
        this.lines = lines;
        return;
      }
    },
    async getStereotypes() {
      var stereotypes = store.getters.getStereotypes;
      if (stereotypes.length == 0) {
        store.dispatch("getStereotypes").then(() => {
          stereotypes = store.getters.getStereotypes;
          this.stereotypes = stereotypes;
        });
      } else {
        this.stereotypes = stereotypes;
      }
    },
    async getPromotions() {
      var promotions = store.getters.getPromotions;
      if (promotions.length == 0) {
        store.dispatch("getPromotions").then(() => {
          promotions = store.getters.getPromotions;
          this.promotions = promotions;
        });
      } else {
        this.promotions = promotions;
      }
    },
    crear(event) {
      event.target.classList.add("was-validated");
      var {
        name,
        description,
        dateStart,
        dateEnd,
        linesSelected,
        promotionSelected,
        stereotypesSelected
      } = this;
      this.isLoading = true;
      if (
        name == "" ||
        description == "" ||
        dateStart == "" ||
        dateEnd == "" ||
        linesSelected.length == 0 ||
        promotionSelected.length == 0 ||
        stereotypesSelected.length == 0
      ) {
        this.isLoading = false;
      } else {
        var lines_ids = [];
        linesSelected.map(i => {
          lines_ids.push(i.id);
        });
        var stereotype_ids = [];
        stereotypesSelected.map(i => {
          stereotype_ids.push(i.id);
        });
        var strategyAction = {
          name,
          description,
          dateStart,
          dateEnd,
          lines_ids,
          stereotype_ids,
          promotion_id: promotionSelected.id,
          linesSelected,
          stereotypesSelected,
          promotionSelected
        };
        store.dispatch("newStretegyAction", strategyAction).then(() => {
          this.name = "";
          this.description = "";
          this.dateStart = "";
          this.dateEnd = "";
          this.linesSelected = [];
          this.onClick();
          this.isLoading = false;
        });
      }
    },
    crearLine(event) {
      event.target.classList.add("was-validated");
      var { nameLine, descriptionLine } = this;
      this.isLoadingLine = true;
      if (nameLine == "" || descriptionLine == "") {
        this.isLoadingLine = false;
      } else {
        var line = {
          nameLine,
          descriptionLine
        };
        store.dispatch("newLine", line).then(() => {
          this.nameLine = "";
          this.descriptionLine = "";
          this.isLoadingLine = false;
          this.modal = false;
        });
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.prueba-circulo {
  background-image: url("");
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
  background: #cccccc;
  border-radius: 100%;
  position: relative;
}
.form {
  position: relative;
  bottom: 80px;
}
</style>